import { ErrorCodes } from './enums/error-codes.enum';

export class ErrorModel {
  errorDescription: string;
  readonly errorDetails?: string;
  readonly errorCode: ErrorCodes;
  readonly memberName?: string;
  readonly originalDescription: string;

  constructor(data: {
    errorCode: ErrorCodes;
    errorDescription: string;
    memberName?: string;
    errorDetails?: string;
  }) {
    this.errorCode = data.errorCode;
    this.errorDescription = data.errorDescription;
    this.originalDescription = data.errorDescription;
    this.errorDetails = data.errorDetails;
    this.memberName = data.memberName;
  }

  toString(): string {
    return `[ErrorCode#${this.errorCode}] ${this.errorDescription}`;
  }
}

export class BackendResponseModel {
  get errors(): ErrorModel[] {
    return this._errors;
  }

  isShowNotification = true;
  data: any;

  private _errors: ErrorModel[] = [];

  addError(data: {
    errorCode: ErrorCodes;
    errorDescription: string;
    errorDetails?: string;
    memberName?: string;
  }): ErrorModel {
    let error = this.errors.find((t) => t.errorCode === data.errorCode);

    if (!error) {
      error = new ErrorModel(data);
      this.errors.push(error);
    }

    return error;
  }
}
